// extracted by mini-css-extract-plugin
module.exports = {"preloader__wrapper":"Preloader_preloader__wrapper__1eH84","preloader":"Preloader_preloader__b8K5E","spin":"Preloader_spin__3nx3O"};